export const ERROR = {
  EMPTY: {
    REQUIRED_INFO: 'Esta información es requerida',
  },
}
